module.exports = __webpack_public_path__ + "img/telegram.8fe58eea.png";